import shopifyWarehouseGenericDefaults from '../shopify-warehouse-generic/config.js';

window.Convermax.filteredByVehicle = () => window.document.body.classList.contains('cm_filtered_by_vehicle');

function responseHandler(response) {
  const { Facets } = response;
  const isFilteredByVehicle = !Facets.find(
    (f) => f.FieldName === 'FilterByVehicle' && f.Selection.length > 0,
  );

  window.document.body.classList.toggle('cm_filtered_by_vehicle', isFilteredByVehicle);

  return response;
}

export default {
  includes: ['shopify-warehouse-generic'],
  ...shopifyWarehouseGenericDefaults,
  responseHandler,
  Widgets: [
    ...shopifyWarehouseGenericDefaults.Widgets.filter((w) => !['SearchVehicleWidget'].includes(w.name)),
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 700,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters &&
        shopifyWarehouseGenericDefaults.fitmentSearch.baseFields,
      facetToggleConfig: {
        isInverted: true,
        toggledFacet: { field: 'FilterByVehicle', term: 'False' },
      },
    },
  ],
};
